import { t } from './i18n';

const nf = new Intl.NumberFormat('en-US');
export const num = (n: number | null | undefined): string => (n == null ? '—' : nf.format(n));

/** date and time in Cambodia, the way the owner reads it: 21-09-2026 16:30 */
export function dateTime(v: string | null | undefined): string {
  if (!v) return '—';
  const d = new Date(v);
  const p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Phnom_Penh', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(d);
  const g = (k: string) => p.find((x) => x.type === k)?.value ?? '';
  return `${g('day')}-${g('month')}-${g('year')} ${g('hour')}:${g('minute')}`;
}

export function date(v: string | null | undefined): string {
  return v ? dateTime(v).slice(0, 10) : '—';
}

/** "Today", "Yesterday", "5 days ago" */
export function age(v: string | null | undefined): string {
  if (!v) return t('Never');
  const days = Math.floor((Date.now() - new Date(v).getTime()) / 86_400_000);
  return days <= 0 ? t('Today') : days === 1 ? t('Yesterday') : `${days} ${t('days ago')}`;
}
